import {Type, Dom, ajax, Loc} from 'main.core';
import "ui.notifications";
import "ui.sidepanel";

export class Page
{
	static initTask( options )
	{
		return new Page(options);
	}

	constructor(options = {name: 'Page'})
	{
		this.node   = BX.prop.getElementNode(options, 'node', Dom.create('div'));
		this.taskId = BX.prop.getNumber(options, 'taskId', 0);
		this.data   = {};

		if ( this.taskId > 0 )
		{
			this.draw();
		}
	}

	draw()
	{
		ajax.runAction(
			'fusion:tasknegotiate.Page.getConfig',
			{
				data: {
					taskId: this.taskId
				}
			}
		).then(
			(response) => {
				this.data = response.data;
				this.render();
			},
			(response) => {
				BX.UI.Notification.Center.notify({
					content: response.errors[0].message,
				});
			}
		);
	}

	render()
	{
		Dom.clean(this.node);

		let container = Dom.create('div');

		if (
			this.data.request.state_code == 'DRAFT'
			&& this.data.access.canSend
		)
		{
			let buttonNode = Dom.create('button', {
				attrs: {
					className: 'ui-btn ui-btn-primary'
				},
				events: {
					click: BX.delegate(this.onStartButtonClicked, this) 
				},
				text: Loc.getMessage('FUSION_TESKNEGOTIATE_PAGE_NEGOTIATE')
			});

			Dom.append(buttonNode, container);
		}

		if (this.data.request.state_code == 'NEW')
		{
			if ( this.data.access.canApprove )
			{
				let accept = Dom.create('button', {
					attrs: {
						className: 'ui-btn ui-btn-success'
					},
					events: {
						click: () => {
							this.makeDecision(this.data.request.id, 'Y');
						} 
					},
					text: Loc.getMessage('FUSION_TESKNEGOTIATE_PAGE_APPROVE')
				});

				let decline = Dom.create('button', {
					attrs: {
						className: 'ui-btn ui-btn-danger'
					},
					events: {
						click: () => {
							this.makeDecision(this.data.request.id, 'N');
						} 
					},
					text: Loc.getMessage('FUSION_TESKNEGOTIATE_PAGE_DECLINE')
				});

				Dom.append(accept, container);
				Dom.append(decline, container);
			}
			else
			{
				let describeNode = Dom.create('div', {
					attrs: {
						className: 'task-negotiation-describe'
					},
					children: [
						BX.create('div', {
							attrs: {
								className: "task-negotiation-describe-state"
							},
							text: Loc.getMessage('FUSION_TESKNEGOTIATE_PAGE_REQUEST_SEND')
						}),
						BX.create('div', {
							attrs: {
								className: "task-negotiation-describe-date"
							},
							text: BX.Main.Date.format('d.m.Y H:i', BX.Main.Date.getNewDate(this.data.request.created_at))
						})
					]
				});
				Dom.append(describeNode, container);
			}
		}

		Dom.append(container, this.node);
	}

	onStartButtonClicked()
	{
		Page.openForTask(this.taskId).then(()=>{
			this.draw();
		});
	}

	makeDecision( negotiateId, decisionLetter )
	{
		ajax.runAction(
			'fusion:tasknegotiate.Negotiate.makeDecision',
			{
				data: {
					id: negotiateId,
					decision: decisionLetter
				}
			}
		).then(
			(response) => {
				Dom.clean(this.node);
				this.draw();
			},
			(response) => {
				BX.UI.Notification.Center.notify({
					content: response.errors[0].message,
				});
			}
		);
	}

	static openForTask( taskId )
	{
		return (new Promise((resolve, reject)=>{
			BX.SidePanel.Instance.open("/page/task_negotiate/create/?taskId="+taskId, {
				cacheable: false,
				allowChangeHistory: false,
				allowChangeTitle: false,
				width: 450,
				events: {
					onClose: (event) => {
						resolve();
					}
				}
			});
		}));
	}
}